import { PersonalInformation } from '../../../interfaces/PersonalInformation';

export default function transformFormRequest(values: PersonalInformation) {
  return {
    phoneNumbers: {
      phoneNumberHome: values?.phones.home,
      phoneNumberWork: values?.phones.work,
      phoneNumberWorkExtension: values?.phones.workExtension,
      phoneNumberCell: values?.phones.cell,
      phoneNumberFax: values?.phones.fax,
    },
    emails: {
      emailHome: values?.emails.home,
      emailWork: values?.emails.work,
    },
    address: values.newAddress ? {
      civicNumber: values.newAddress.buildingNumber,
      street: values.newAddress.street,
      city: values.newAddress.city,
      province: values.newAddress.province,
      country: values.newAddress.countryIso2,
      postalCode: values.newAddress.postalCode,
      appartementOrSuite: values.newAddress.subBuilding,
      appartementOrSuiteType: values.newAddress.subBuildingType === 'none' ? '' : values.newAddress.subBuildingType,
      externalPlace: values.newAddress.place,
      deliveryMethod: values.newAddress.deliveryType === 'none' ? '' : values.newAddress.deliveryType,
      postOfficeBox: values.newAddress.poBoxNumber,
      ruralRoute: values.newAddress.ruralRoute,
    } : values.address,
    correspondence: {
      language: values?.correspondence.language,
    },
  };
}
